var _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 249,
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.17 189.782V189.981C222.126 192.678 220.338 195.362 216.811 197.414L138.665 242.846C131.469 247.027 119.768 247.019 112.528 242.838L33.871 197.414C30.2382 195.313 28.4141 192.56 28.4141 189.806C28.4141 189.274 28.4837 188.748 28.6205 188.224C29.1804 186.045 30.8987 183.95 33.7858 182.275L111.932 136.851C119.128 132.67 130.824 132.662 138.069 136.843L216.726 182.275C219.657 183.97 221.404 186.087 221.971 188.288C222.098 188.786 222.17 189.282 222.17 189.785V189.782Z",
    fill: "url(#paint0_linear_1_3252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.3 248.953C134.664 248.837 135.028 248.705 135.387 248.568C135.436 248.548 135.482 248.527 135.539 248.506C135.931 248.354 136.308 248.192 136.684 248.019C136.795 247.964 136.904 247.915 137.007 247.861C137.425 247.662 137.83 247.456 138.214 247.229L213.832 203.268C213.907 203.227 213.984 203.186 214.051 203.145C214.374 202.951 214.676 202.747 214.965 202.546C215.014 202.512 215.06 202.476 215.109 202.443C215.44 202.203 215.749 201.963 216.03 201.715C216.079 201.673 216.121 201.64 216.162 201.604C216.211 201.555 216.273 201.508 216.319 201.467C216.546 201.253 216.758 201.033 216.964 200.814C217.006 200.765 217.039 200.724 217.08 200.677C217.197 200.54 217.32 200.409 217.424 200.272C217.514 200.161 217.589 200.053 217.664 199.942C217.692 199.9 217.725 199.867 217.754 199.826C217.898 199.619 218.027 199.413 218.146 199.201C218.187 199.131 218.221 199.064 218.257 198.994C218.278 198.945 218.306 198.904 218.327 198.863C218.438 198.636 218.538 198.409 218.629 198.184C218.649 198.13 218.662 198.073 218.683 198.019C218.696 197.978 218.711 197.936 218.724 197.895C218.799 197.655 218.868 197.415 218.915 197.18L218.936 197.036C218.943 196.994 218.948 196.953 218.956 196.904C218.997 196.656 219.026 196.403 219.031 196.148V195.99L219.039 188.157C218.997 190.767 217.266 193.363 213.855 195.35L138.238 239.311C131.274 243.358 119.952 243.35 112.947 239.303L36.8342 195.348C33.3175 193.314 31.5527 190.65 31.5527 187.984L31.5449 195.936C31.5372 198.607 33.2891 201.232 36.8109 203.266L112.929 247.226C113.347 247.466 113.788 247.693 114.24 247.905C114.392 247.98 114.55 248.042 114.699 248.112C114.968 248.228 115.228 248.352 115.509 248.463C115.551 248.483 115.605 248.496 115.654 248.517C115.749 248.55 115.86 248.586 115.963 248.628C116.314 248.759 116.678 248.881 117.05 248.999",
    fill: "url(#paint1_linear_1_3252)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.732 0.647678C158.19 -0.820853 156.119 0.356036 156.111 3.28277L155.84 98.6134C155.832 101.54 157.891 105.102 160.432 106.57L243.37 154.469C245.917 155.94 247.983 154.761 247.991 151.834L248.262 56.5035C248.27 53.5767 246.216 50.0177 243.669 48.5466L160.732 0.647678Z",
    fill: "url(#paint2_linear_1_3252)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5302 1.42136C90.0716 -0.0471714 92.1434 1.12972 92.1511 4.05646L92.4221 99.3871C92.4298 102.314 90.3709 105.875 87.8295 107.344L4.89191 155.243C2.34534 156.714 0.278673 155.534 0.270933 152.608L2.18073e-05 57.2771C-0.00771851 54.3504 2.04605 50.7913 4.59261 49.3202L87.5302 1.42136Z",
    fill: "url(#paint3_linear_1_3252)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.38 6.57737C147.839 5.10883 145.767 6.28572 145.759 9.21246L145.488 104.543C145.481 107.47 147.539 111.031 150.081 112.5L233.018 160.399C235.565 161.87 237.632 160.69 237.639 157.764L237.91 62.4331C237.918 59.5064 235.864 55.9473 233.318 54.4762L150.38 6.57737Z",
    fill: "url(#paint4_linear_1_3252)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.077 5.2844C100.618 3.81587 102.69 4.99275 102.698 7.91949L102.969 103.25C102.977 106.177 100.918 109.738 98.3763 111.207L15.4388 159.106C12.8922 160.577 10.8255 159.398 10.8178 156.471L10.5469 61.1402C10.5392 58.2134 12.5929 54.6544 15.1395 53.1833L98.077 5.2844Z",
    fill: "url(#paint5_linear_1_3252)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.029 11.2766C137.487 9.80805 135.415 10.9849 135.408 13.9117L135.137 109.242C135.129 112.169 137.188 115.731 139.729 117.199L222.667 165.098C225.213 166.569 227.28 165.39 227.288 162.463L227.559 67.1324C227.566 64.2056 225.513 60.6466 222.966 59.1755L140.029 11.2766Z",
    fill: "url(#paint6_linear_1_3252)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 73.2902C198.279 73.8632 199.081 75.2517 199.076 76.3951C199.074 77.5332 198.266 77.9926 197.273 77.4197L169.743 61.5213C168.752 60.9484 167.953 59.5624 167.955 58.4243C167.958 57.2835 168.765 56.8215 169.756 57.3945L197.286 73.2928V73.2902Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 88.8647C198.279 89.4377 199.081 90.8262 199.076 91.9695C199.074 93.1077 198.266 93.5671 197.273 92.9941L169.743 77.0958C168.752 76.5228 167.953 75.1369 167.955 73.9987C167.958 72.858 168.765 72.396 169.756 72.969L197.286 88.8673V88.8647Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 107.704C198.279 108.277 199.081 109.666 199.076 110.809C199.074 111.947 198.266 112.407 197.273 111.834L169.743 95.9354C168.752 95.3624 167.953 93.9765 167.955 92.8383C167.958 91.6976 168.765 91.2356 169.756 91.8086L197.286 107.707V107.704Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 150.892C198.279 151.465 199.081 152.853 199.076 153.997C199.074 155.135 198.266 155.594 197.273 155.021L169.743 139.123C168.752 138.55 167.953 137.164 167.955 136.026C167.958 134.885 168.765 134.423 169.756 134.996L197.286 150.894V150.892Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3252",
    x1: 125.292,
    y1: 245.976,
    x2: 125.292,
    y2: 133.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7100FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A423FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3252",
    x1: 125.291,
    y1: 186.351,
    x2: 125.291,
    y2: 249.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3252",
    x1: 155.84,
    y1: 77.5584,
    x2: 248.262,
    y2: 77.5584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7100FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A423FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_3252",
    x1: 92.4221,
    y1: 78.3321,
    x2: 0.0000220351,
    y2: 78.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7100FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A423FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_3252",
    x1: 145.488,
    y1: 83.4881,
    x2: 237.91,
    y2: 83.4881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7100FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A423FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_3252",
    x1: 102.969,
    y1: 82.1951,
    x2: 10.5469,
    y2: 82.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7100FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A423FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_3252",
    x1: 135.137,
    y1: 88.1873,
    x2: 227.559,
    y2: 88.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7100FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A423FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2);
export default __webpack_public_path__ + "static/media/b2.013f6086566c36354603e4e7cd7f3347.svg";
export { ForwardRef as ReactComponent };